import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Auth, GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup, browserLocalPersistence, inMemoryPersistence, sendPasswordResetEmail, FacebookAuthProvider, signInWithRedirect, createUserWithEmailAndPassword } from '@angular/fire/auth';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { AppService } from '../../services/app.service';
import { UserService } from '../../services/user.service';
import { BusinessService } from '../../services/business.service';
import { FirebaseError } from '@angular/fire/app';

@Component({
  selector: 'brt-login',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ButtonModule, RippleModule, DialogModule,
    PasswordModule, CheckboxModule, RippleModule, InputTextModule, InputMaskModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  current: any;
  partner: any;
  get isMainComponent() { return this.route.component == <any>this.constructor; }
  constructor(private route: ActivatedRoute, private auth: Auth,
    private userService: UserService, appService: AppService,
    private businessService: BusinessService,
    private cdRef: ChangeDetectorRef) {
    userService.current$.pipe(takeUntilDestroyed()).subscribe((current) => {
      this.current = current;
      if (this.displayAuth && current) {
        this.displayAuth = false;
        this.cdRef.detectChanges();
      }
    });
    appService.activeBusiness$.pipe(takeUntilDestroyed()).subscribe(business => this.partner = business);
  }
  @Input() mode: 'popup' | 'inline';
  name: string;
  username: string;
  password: string;
  code: string;
  rememberMe: boolean = true;
  error: string;
  displayAuth: boolean;
  busy: boolean;
  page: 'signup' | 'login' | 'reset' = 'login';

  // Side artwork shown next to the form on the full-page login. All three
  // values are read from the system config (UI settings) so they can be
  // customised from the dashboard without a code change.
  loginImage: string;
  loginTitle: string;
  loginCaption: string;

  // recaptchaVerifier: RecaptchaVerifier;
  // confirmationResult: ConfirmationResult;
  ngOnInit() {
    if (this.isMainComponent && !this.mode)
      this.mode = 'inline';

    // Allow deep-linking straight into the sign-up tab, e.g. /login?page=signup.
    const requestedPage = this.route.snapshot.queryParams['page'];
    if (requestedPage == 'signup' || requestedPage == 'reset')
      this.page = requestedPage;

    if (this.isMainComponent)
      this.loadLoginArtwork();
    // this.recaptchaVerifier = new RecaptchaVerifier(this.auth, 'captcha-verifier', {
    //   'size': 'invisible',
    //   'callback': (response) => console.log('captcha', response)
    // });
  }

  private async loadLoginArtwork() {
    try {
      const config = await this.businessService.getSystemConfig();
      const ui = config?.UI || {};
      this.loginImage = ui['LoginImage'];
      this.loginTitle = ui['LoginImageTitle'];
      this.loginCaption = ui['LoginImageCaption'];
      this.cdRef.detectChanges();
    } catch {
      // Config is optional artwork; the form still works without it.
    }
  }

  handleError(error: FirebaseError) { this.error = error.code; }

  afterLogin() {
    this.displayAuth = false;
    location.reload();
  }

  goto(page: 'signup' | 'login' | 'reset') {
    this.page = page;
    this.error = null;
  }

  resetPassword() {
    this.busy = true;
    delete this.error;
    sendPasswordResetEmail(this.auth, this.username)
      .then(() => this.error = 'reset-email-sent')
      .catch(error => this.handleError(error))
      .finally(() => this.busy = false);
  }

  signUpWithEmailAndPassword() {
    this.busy = true;
    delete this.error;
    this.auth.setPersistence(this.rememberMe ? browserLocalPersistence : inMemoryPersistence);
    createUserWithEmailAndPassword(this.auth, this.username, this.password)
      .then(async () => {
        await this.userService.saveProfile({ Name: this.name });
        this.afterLogin();
      })
      .catch(error => this.handleError(error))
      .finally(() => this.busy = false);
  }


  signInWithEmailAndPassword() {
    this.busy = true;
    delete this.error;
    this.auth.setPersistence(this.rememberMe ? browserLocalPersistence : inMemoryPersistence);
    signInWithEmailAndPassword(this.auth, this.username, this.password)
      .then(() => this.afterLogin())
      .catch(error => this.handleError(error))
      .finally(() => this.busy = false);
  }
  signInWithGoogle() {
    this.busy = true;
    const provider = new GoogleAuthProvider();
    this.auth.setPersistence(this.rememberMe ? browserLocalPersistence : inMemoryPersistence);
    signInWithPopup(this.auth, provider)
      .then(() => this.afterLogin())
      .catch(error => this.handleError(error))
      .finally(() => this.busy = false);
  }

  // signInWithMobilePhone() {
  //   this.busy = true;
  //   signInWithPhoneNumber(this.auth, this.username, this.recaptchaVerifier)
  //     .then((confirmationResult) => this.confirmationResult = confirmationResult)
  //     .catch(error => this.handleError(error))
  //     .finally(() => this.busy = false);
  // }
  // confirmMobileCode() {
  //   this.busy = true;
  //   this.confirmationResult.confirm(this.code)
  //     .then(() => window.location.reload())
  //     .catch(error => this.handleError(error))
  //     .finally(() => this.busy = false);
  // }

  signInWithFacebook() {
    this.busy = true;
    const provider = new FacebookAuthProvider();
    signInWithRedirect(this.auth, provider)
      .then(() => this.afterLogin())
      .catch(error => this.handleError(error))
      .finally(() => this.busy = false);
  }
}
